// extracted by mini-css-extract-plugin
export default {"tag":"caZws","tag__icon":"WVpRQ","tag__text":"aUGHw"};